import { useDialog } from "lib/@hooks/useDialog"
import { MaintenanceTaskElementSelectorDialog } from "./maintenance-task-element-selector-dialog"

export function useMaintenanceTaskElementSelectorDialog(props = {}) {
    return useDialog(<MaintenanceTaskElementSelectorDialog {...props} />, {
        maxWidth: "lg",
        "data-cy": "maintenance-selector-dialog",
    })
}
